import { useCallback, useMemo } from 'react'

import withDataContext from 'context/consumerHOC/DataConsumer'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import EventItem from 'components/pages/events/EventItem'

const EventList = ({ router, eventsData, onCategoryChange, loadMoreEvents, pageParams }) => {
    //! Store Events
    const storeEventItems = useMemo(() => {
        return eventsData?.events.map((event, index) => (
            <EventItem
                index={index}
                className='event-page-item col-3 col-dl-3 col-dm-3 col-ds-3 col-dxs-3 col-t-4 col-ts-6 col-m-12'
                key={event.id}
                data={event}
                onCategoryChange={onCategoryChange}
            />
        ))
    }, [eventsData, onCategoryChange])

    //! Load More
    const loadMore = useCallback(() => {
        loadMoreEvents({
            pageParams,
            queryParams: {
                ...router.query,
                offset: eventsData.events.length,
            },
        })
    }, [eventsData, router])

    return (
        <>
            <Container className='event-page-items-wrap' full row>
                {storeEventItems}
            </Container>
            {eventsData?.hasMore && (
                <div className='load-btn' role={'button'} onClick={loadMore}>
                    <Text className={'pS font-ping-bolder'} text={'loadMore'} />
                </div>
            )}
        </>
    )
}

export default withDataContext(EventList, ['loadMoreEvents'])
